module.exports = __webpack_public_path__ + "img/swedish.34436254.png";